
const digest = 'e5d5dae59a8fdfcc028a6c35658d443f03d6b6dd90740dd5f779da136aa335f3';
const classes = {"wrapper":"_wrapper_8ya6m_1","date":"_date_8ya6m_13","content":"_content_8ya6m_19","title":"_title_8ya6m_27","cancelInfo":"_cancelInfo_8ya6m_31","controls":"_controls_8ya6m_37"};
const css = `._wrapper_8ya6m_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 19px;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_8ya6m_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_8ya6m_1 ._date_8ya6m_13 {
  font-size: 14px;
  color: #000000;
  min-width: 120px;
  max-width: 120px;
}
._wrapper_8ya6m_1 ._content_8ya6m_19 {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 24px;
}
._wrapper_8ya6m_1 ._content_8ya6m_19 ._title_8ya6m_27 {
  font-size: 14px;
  font-weight: 500;
}
._wrapper_8ya6m_1 ._content_8ya6m_19 ._cancelInfo_8ya6m_31 {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  gap: 5px;
}
._wrapper_8ya6m_1 ._controls_8ya6m_37 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  